import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { DnpeService } from '@k12/app-services';
import { catchError, map, Observable, of } from 'rxjs';
import { DnpeLookupResult } from '@k12/models';

export function DnpeLookupValidator(dnpeService: DnpeService):AsyncValidatorFn  {
  return (control: AbstractControl): Observable<Record<string, boolean> | null> => {
    let lookupStatus: Record<string, boolean> | null;
    return dnpeService.lookupDnpe(control.value).pipe(
      map((result: DnpeLookupResult) => {
        if (result.school?.status === 'Closed') {
          lookupStatus = { Closed: true };
        } else if (result.status !== 'NotYetRegistered') {
          lookupStatus = { [result.status]: true };
        }
        return lookupStatus;
      }),
      catchError((error) => {
        if (error.error.message === 'DNPE ID not found.') {
          lookupStatus = { NotFound: true };
        }
        return of(lookupStatus);
      })
    );
  }
}
